'use strict';
var processInclude = require('base/util');
processInclude(require('./jquery.datetextentry'));
var now = new Date();
var $year = now.getFullYear() - 18;
var $month = '' + now.getMonth();
var $date = '' + now.getDate();

if ($month.length < 2) {
    $month = '0' + $month;
}
if ($date.length < 2) {
    $date = '0' + $date;
}
var eighteenYears = [$year, $month, $date].join('-');

var $minAllowedYear = now.getFullYear() - 100;
var past100Years = [$minAllowedYear, $month, $date].join('-');

function initCustomSelect() {
    var x, i, j, l, ll, selElmnt, a, b, c;
        /* Look for any elements with the class "custom-select": */
        x = document.getElementsByClassName("custom-select");
        l = x.length; 
        for (i = 0; i < l; i++) {
            selElmnt = x[i].getElementsByTagName("select")[0];
            ll = selElmnt.length;
            /* For each element, create a new DIV that will act as the selected item: */
            a = document.createElement("DIV");
            a.setAttribute("class", "select-selected");
            a.innerHTML = typeof selElmnt.options[selElmnt.selectedIndex] !== 'undefined' ? selElmnt.options[selElmnt.selectedIndex].innerHTML : '';
            
            x[i].appendChild(a);
            /* For each element, create a new DIV that will contain the option list: */
            b = document.createElement("DIV");
            b.setAttribute("class", "select-items select-hide");
            for (j = 1; j < ll; j++) {
                /* For each option in the original select element,
                create a new DIV that will act as an option item: */
                c = document.createElement("DIV");
                c.innerHTML = selElmnt.options[j].innerHTML;
                var disa = selElmnt.options[j].getAttribute('disabled');
                c.setAttribute('class', disa ? disa : '');
                c.addEventListener("click", function (e) {
                    /* When an item is clicked, update the original select box,
                    and the selected item: */
                    var y, i, k, s, h, sl, yl;
                    const ek = new Event("change");
                    s = this.parentNode.parentNode.getElementsByTagName("select")[0];
                    sl = s.length;
                    h = this.parentNode.previousSibling;
                    for (i = 0; i < sl; i++) {
                        if (s.options[i].innerHTML == this.innerHTML) {
                            s.selectedIndex = i;
                            h.innerHTML = this.innerHTML;
                            y = this.parentNode.getElementsByClassName("same-as-selected");
                            yl = y.length;
                            for (k = 0; k < yl; k++) {
                                y[k].removeAttribute("class");
                                s.options[k].removeAttribute('selected');
                            }
                            s.options[i].setAttribute('selected','true');
                            this.setAttribute("class", "same-as-selected");
                            $(s).trigger('change');
                            break;
                        }
                    }
                    h.click();
                });
                b.appendChild(c);
            }
            x[i].appendChild(b);
            a.addEventListener("click", function (e) {
                /* When the select box is clicked, close any other select boxes,
                and open/close the current select box: */
                e.stopPropagation();
                closeAllSelect(this);
                this.nextSibling.classList.toggle("select-hide");
                this.classList.toggle("select-arrow-active");
            });
        }
        
        function closeAllSelect(elmnt) {
            /* A function that will close all select boxes in the document,
            except the current select box: */
            var x, y, i, xl, yl, arrNo = [];
            x = document.getElementsByClassName("select-items");
            y = document.getElementsByClassName("select-selected");
            xl = x.length;
            yl = y.length;
            for (i = 0; i < yl; i++) {
                if (elmnt == y[i]) {
                    arrNo.push(i)
                } else {
                    y[i].classList.remove("select-arrow-active");
                }
            }
            for (i = 0; i < xl; i++) {
                if (arrNo.indexOf(i)) {
                    x[i].classList.add("select-hide");
                }
            }
        }
        
        /* If the user clicks anywhere outside the select box,
        then close all select boxes: */
        document.addEventListener("click", closeAllSelect);
};

module.exports = {
    initForm: function() {
        if ($('.edit-profile-form, .registration, .js-add-payment-form, #contact-us-id').length > 0) {
            initCustomSelect();
        }
        // $(document).on('focus', 'input.form-control:not([type=hidden])', function() {
        //     var $this = $(this);
        //     var $parent = $this.closest('.form-group');
        //     var $label = $parent.find('label');
        //     $parent.addClass('in-focus');
        //     $label.addClass('active');
        // });
        
        // $(document).on('blur', 'input.form-control:not([type=hidden])', function() {
        //     var $this = $(this);
        //     var $parent = $this.parent();
        //     var $label = $parent.find('label');
        //     var $val = $this.val();
            
        //     if ($val.length === 0) {
        //         $label.removeClass('active');
        //     }
        //     $parent.removeClass('in-focus');
        // });

        // $(document).on('click', 'label.form-control-label', function() {
        //     var $this = $(this);
        //     var $parent = $this.closest('.form-group');
        //     var $label = $this;
        //     $parent.addClass('in-focus');
        //     $label.addClass('active');
        //     $parent.find('.form-control').focus();
        // });
       
        // $(document).ready(function(){
        //     $('.form-group input:not([type=hidden])').each(function() {
        //         var $this = $(this);
        //         var $parent = $this.parent();
        //         var $label = $parent.find('label');
        //         var $val = $this.val();
        //         if ($val.length > 0) {
        //             $label.addClass('active');
        //             $parent.addClass('in-focus');
        //         }
        //     })            
        // });
    },
    radioButton: function () {
        $(document).on('click', '.js-radio-trigger .input-field', function (e) {
            e.preventDefault();
            var $this = $(this);
            var $data = $this.data('type');
            var $input = $this.parent().find('input');
            $this.addClass('selected').siblings().removeClass('selected');
            $input.val($data);
        });
    },
    onlyNumbers: function () {
        $('.js-number-only').on('keypress', function (e) {
            var charCode = (e.which) ? e.which : event.keyCode;
            if (String.fromCharCode(charCode).match(/[^0-9]/g))
                return false;
        });    
    },
    revealPassword: function () {
        $(document).on('click', '.js-reveal-password', function (e) {
            var $this = $(this);
            var $parent = $this.parent();
            var $input = $parent.find('.form-control');
            var $type = $input.attr('type');

            if ($type === 'password') {
                $input.attr('type', 'text');
                $this.addClass('uil-eye-slash').removeClass('uil-eye');
            } else {
                $input.attr('type', 'password');
                $this.addClass('uil-eye').removeClass('uil-eye-slash');
            }
        })
    },
    dob: function () {
        $('#js-birthday').datetextentry({
            'field_width_day': 18,
            'field_width_month': 18,
            'field_width_year': 85,
            'show_errors': false,
            'max_date': eighteenYears,
            'max_date_message': 'You should be above 18 years of age',
            min_date: past100Years,
            min_date_message: resources.E_MIN_DATE,
            'show_tooltips': false,
            'on_error': function (msg) {
                if (msg !== '') {
                    $('label.date-label').addClass('is-invalid').text(msg);
                    $('label.date-label').closest('.form-group').addClass('is-invalid');
                } else {
                    var datafiled = $('label.date-label').data('label');
                    $('label.date-label').removeClass('is-invalid').text(datafiled);
                    $('label.date-label').closest('.form-group').removeClass('is-invalid');
                }
            },
            'E_BAD_DAY_FOR_MONTH': 'Only %d days in %m',
            'E_DAY_NAN': 'Day must be a number',
            'E_DAY_TOO_BIG': 'Day must be 1-31',
            'E_DAY_TOO_SMALL': 'Day must be 1-31 ',
            'E_MAX_DATE': 'Date must not be later than %DATE',
            'E_MIN_DATE': 'Date must not be earlier than %DATE ',
            'E_MONTH_NAN': 'Month must be a number',
            'E_MONTH_TOO_BIG': 'Month must be 1-12',
            'E_MONTH_TOO_SMALL': 'Month must be 1-12',
            'E_REQUIRED_FIELD': 'This field is required',
            'E_YEAR_LENGTH': 'Year must be 4 digits',
            'E_YEAR_NAN': 'Year must be a number',
            'E_YEAR_TOO_BIG': 'Year must not be after %y',
            'E_YEAR_TOO_SMALL': 'Year must not be before %y'
        });
    }
};



